<template>
    <div>
        <div v-show="isLoaded">
            <div class="level">
                <div class="level-item level-left">
                    <div class="buttons">
                        <b-button type="is-dark" @click="goTo('create')" v-if="isRole('superadmin')">
                            Create Topic
                        </b-button>
                    </div>
                </div>
                <div class="level-item level-right">
                    <app-filter v-model="application_id" :nullable="true" @input="getTopics" :preSelect="this.$store.state.guide_application_id"/>
                </div>
            </div>
            <b-table :data="topics" :columns="columns">
                <template slot-scope="props">
                    <b-table-column>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column>
                        {{props.row.attributes.title}}
                    </b-table-column>
                    <b-table-column>
                        <div class="buttons">
                            <b-button type="is-primary" size="is-small" position="is-right" class="m0" @click="goTo('edit',props.row)" icon-left="pencil"/>
                            <b-button type="is-danger" size="is-small" position="is-right"  class="m0" @click="deleteTopic(props.row)" icon-left="trash-can"/>
                            <b-button size="is-small" position="is-right" class="m0" @click="steps(props.row)">Steps</b-button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
        <b-loading :isFullPage="false" :active="true" v-if="!isLoaded"></b-loading>
    </div>
</template>

<script>
import Vue from 'vue';
import AppFilter from '../../../../../components/AppFilter.vue';
export default {
    name:"Topic",
    components:{
        AppFilter
    },
    data() {
        return{
            columns:[
                {
                    field:'id',
                    label:'Id'
                },
                {
                    field:'title',
                    label:'Title'
                },
                {
                    field:'actions',
                    label:'Actions'
                },
            ],
            apps:[],
            topics:[],
            isLoaded: true,
            application_id:null
        }
    },
    watch:{
        application_id(newValue){
            this.$store.commit('SET_SELECTED_APP_GUIDE',newValue);
        }
    },
    mounted(){
        this.application_id = this.$store.state.guide_application_id
        this.getAppList()
        this.getTopics()
    },
    methods:{
        getTopics() {
            this.isLoaded = false
            let params = '?without_steps=1';
            if(this.application_id!==null){
                params+=`&application_id=${this.application_id}`
            }
            Vue.$topicService.topicList(params).then(async (response)=>{
                this.topics = response.data
                this.isLoaded = true;
            })
        },
        deleteTopic(topic) {
            this.$buefy.dialog.confirm({
                title: 'Deleting topic',
                message: 'Are you sure you want to <b>delete</b> this topic? This action cannot be undone.',
                confirmText: 'Delete Topic',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    Vue.$topicService.delete(topic.id).then(()=>{
                        this.$buefy.toast.open({
                            message:"Topic deleted!",
                            type:'is-success'
                        });
                        this.$store.commit("SET_ERRORS", null);
                        this.loading = false;
                    })
                }
            })
        },
        goTo(type,model = null) {
            if(type==='create') this.$router.push({ name:'topics.create' })
            if(type==='edit' && model) this.$router.push({ name:'topics.edit',
                params: {
                    id: model.id
                }})
        },
        steps(topic){
            this.$store.commit('SET_SELECTED_APP_GUIDE',topic.attributes.application_id);
            this.$emit('step',topic.id);
        },
        getAppList() {
            Vue.$appService.appList().then((response)=>{
                this.apps = response
            })
        },
    },
}
</script>